/* eslint-disable */
/*
 * Interception is a generic interface for interceptor.
 * We specify any type for body and response because its a generic interface.
 */
export interface Interception {
  url: string;
  method: 'POST' | 'GET';
  body?: any;
  timeout?: boolean;
  status?: number;
  response: any;
}
